/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from 'react';
//import MenuCompetencePerformanceEvaluation from "../Components/MenuCompetencePerformanceEvaluation";
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { createStyles, withStyles } from '@material-ui/core';
import { Theme } from '@material-ui/core/styles';
// import { useEffect } from 'react';
// import TablePagination from '@mui/material/TablePagination';
// import TableSortLabel from '@mui/material/TableSortLabel';

const StyledTableCell = withStyles((theme: Theme) =>
  createStyles({
    head: {
      backgroundColor: '#f5f6f9',
      color: '#222222',
      fontFamily: 'Arial',
      fontSize: 14,
      fontWeight: 'bold',
      height: "25px"
    },
    body: {
      fontSize: 14,
    },
  }),
)(TableCell);

interface Data {
    id: number;
    bussinesName: string;
    tipoEvaluacion: string;
    email:string;
  }
  
  function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }
  
  type Order = 'asc' | 'desc';
  
  function getComparator<Key extends keyof any>(
    order: Order,
    orderBy: Key,
  ): (
    a: { [key in Key]: number | string },
    b: { [key in Key]: number | string },
  ) => number {
    return order === 'desc'
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  } 

  function stableSort<T>(array: readonly T[], comparator: (a: T, b: T) => number) {
    const stabilizedThis = array.map((el, index) => [el, index] as [T, number]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) {
        return order;
      }
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }
  
  interface HeadCell {
    disablePadding: boolean;
    id:  keyof Data;
    label: string;   
    width: string; 
    textAlign: boolean;
  }
  
  const headCells: readonly HeadCell[] = [
    {
      id: 'bussinesName',      
      disablePadding: false,
      label: 'Nombre',
      width: '60%',
      textAlign: false
    },
    {
      id: 'tipoEvaluacion',    
      disablePadding: false,
      label: 'Calificación',
      width: '10%',
      textAlign: true
    }
  ];
  
  interface EnhancedTableProps {
    numSelected: number;
    //onRequestSort: (event: React.MouseEvent<unknown>, property: keyof Data) => void;
    order: Order;
    orderBy: string;
    rowCount: number;
  }
  
  function EnhancedTableHead(props: EnhancedTableProps) {  
  
    return (
      <TableHead>
        <TableRow>
           {headCells.map((headCell) => (
            <StyledTableCell
              className="tableHeader"
              key={headCell.id}                   
              padding={headCell.disablePadding ? 'none' : 'normal'}
              //sortDirection={orderBy === headCell.id ? order : false}
              style={{ width: headCell.width, textAlign: headCell.textAlign ? 'right' : 'left' }}
            >
               {/* <TableSortLabel */}
                {/* //active={orderBy === headCell.id}
                //direction={orderBy === headCell.id ? order : 'asc'}
                //onClick={createSortHandler(headCell.id)} */}
                {/* className="labelHeader" */}
              {/* > */}
                {headCell.label}             
              {/* </TableSortLabel> */}
            </StyledTableCell>
          ))} 
        </TableRow>
      </TableHead>
    );
  }

const TableCollaboratorsEvalResults = ({rows,setArrayIncident,selected,setSelected,page,setPage,setViewForCollaborator,setSelectIdColaborador,setMensajeColSel}:any) => {
    const [order, setOrder] = React.useState<Order>("desc");
    const [orderBy, setOrderBy] = React.useState<keyof Data>("bussinesName");  
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [selectedId, setSelectedId] = React.useState<number | null>(null);
  
    const isSelected = (id: number) => selectedId === id;

    const handleRowClick = (id: number, email: string) => {
      if (selectedId === id) {
        setSelectedId(null);
        setSelectIdColaborador(null);
        setViewForCollaborator(false)
        setMensajeColSel('Seleccione un colaborador para ver sus resultados.')        
      } else {
        setSelectedId(id);      
        setSelectIdColaborador(id);
      }
    };
  

    return (
      <Box sx={{ width: "98%" }}>
        <Paper sx={{ width: "98%" }}>
          <TableContainer>
            <Table
              sx={{ minWidth: 290 }}
              aria-labelledby="tableTitle"
            >
              <EnhancedTableHead
                numSelected={selected.length}
                order={order}
                orderBy={orderBy}
                //onRequestSort={handleRequestSort}
                rowCount={rows.length}
              />
              <TableBody>
                {rows.map((row: { id: number; bussinesName: string; email: string; tipoEvaluacion: string }, index: any) => {
                  const castId = Number(row.id)
                  const isItemSelected = isSelected(castId);
                  const labelId = `enhanced-table-checkbox-${index}`;
                  return (
                    <TableRow
                      hover
                      onClick={() => handleRowClick(row.id, row.email)}
                      tabIndex={-1}
                      key={row.id}
                      role="checkbox"
                      aria-checked={isItemSelected}
                      selected={isItemSelected}
                      sx={{ cursor: "pointer" }}
                      style={{ background: isItemSelected ? '#093C5D' : 'inherit' }}
                    >
                      <TableCell
                        component="th"
                        id={labelId}
                        scope="row"
                      >
                        <div style={{
                          fontFamily: 'Roboto',
                          fontSize: '13px',
                          fontWeight: 400,
                          lineHeight: '15.23px',
                          color: isItemSelected ? '#ffff' : '#222222'
                        }}>{row.bussinesName}</div>
                        <div className="containerInfoEmail"> {row.email}  </div>
                      </TableCell>
                      <TableCell align="right"
                        style={{
                          fontFamily: 'Roboto',
                          fontSize: '13px', fontWeight: 400,
                          lineHeight: '15.23px',
                          color: isItemSelected ? '#ffff' : '#222222'
                        }}>{`${row.tipoEvaluacion}%`}</TableCell>
                    </TableRow>
                  );
                })}
                {/* {emptyRows > 0 && (
                  <TableRow>
                    <TableCell colSpan={11} />
                  </TableRow>
                )} */}
              </TableBody>
            </Table>
          </TableContainer>
          {/* <TablePagination
            rowsPerPageOptions={[10, 25, 50]}
            component="div"
            count={rows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            labelRowsPerPage='Número de registros'    
          /> */}
        </Paper>
      </Box>
    );
}

export default TableCollaboratorsEvalResults

